import React, { useState } from "react";
import styles from "./Header.module.scss";
import { useLanguage } from "../../context/Language/LanguageContext";

const Header = () => {
  const { currentLanguage, setLanguage } = useLanguage();
  const [opened, setPlayAnim] = useState(false);

  return (
    <div className={styles.headerWrapper} style={{position:opened?'fixed':'absolute'}}>
      <div className={styles.subpages}>
        <p
          onClick={() => {
            window.open("/", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Home"
          ) : currentLanguage === "sq" ? (
            "Ballina"
          ) : currentLanguage === "sr" ? (
            <>Dom</>
          ) : (
            <>Heim</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/rooms", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Rooms"
          ) : currentLanguage === "sq" ? (
            "Dhomat"
          ) : currentLanguage === "sr" ? (
            <>Sobe</>
          ) : (
            <>Räume</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/gallery", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Gallery"
          ) : currentLanguage === "sq" ? (
            "Galeria"
          ) : currentLanguage === "sr" ? (
            <>Galerija</>
          ) : (
            <>Galerie</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/about", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "About"
          ) : currentLanguage === "sq" ? (
            "Rreth"
          ) : currentLanguage === "sr" ? (
            <>O nama</>
          ) : (
            <>Über Uns</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/contact", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Contact"
          ) : currentLanguage === "sq" ? (
            "Kontakt"
          ) : currentLanguage === "sr" ? (
            <>Kontakt</>
          ) : (
            <>Kontakt</>
          )}
        </p>
      </div>
      <svg
        width="144"
        height="70"
        viewBox="0 0 144 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => {window.open('/','_self')}}
      >
        <path
          d="M87.633 14.8614L86.1621 11.7792C85.8449 11.115 85.1828 10.6815 84.4533 10.6417L84.5643 10.4946C84.9846 9.93382 85.0837 9.20998 84.8299 8.55773L83.5771 5.31241C83.3788 4.79937 82.9744 4.38575 82.4709 4.17497L79.3943 2.89832C78.6489 2.58811 77.7965 2.75514 77.2216 3.31989L76.9559 3.58238V3.41136C76.9559 2.63582 76.504 1.91995 75.8022 1.58587L72.8603 0.193884C72.3132 -0.0646279 71.6907 -0.0646279 71.1436 0.193884L68.2017 1.58587C67.5 1.91597 67.048 2.63185 67.048 3.41136V3.5784L66.7824 3.31989C66.2075 2.75514 65.355 2.58811 64.6097 2.89832L61.533 4.17497C61.0255 4.38575 60.6251 4.79937 60.4269 5.31241L59.174 8.55773C58.9202 9.20998 59.0233 9.93382 59.4396 10.4946L59.5506 10.6417C58.8211 10.6815 58.159 11.115 57.8418 11.7792L56.3709 14.8614C56.1013 15.4222 56.1053 16.0665 56.3828 16.6273L58.0321 19.968C58.3335 20.5845 58.9123 20.9902 59.5784 21.0737C59.0511 21.6305 58.8885 22.4498 59.1542 23.1696L60.2484 26.0928C60.4348 26.5939 60.8075 26.9956 61.2951 27.2183L64.6692 28.7654C65.4383 29.1154 66.3502 28.9484 66.9409 28.3438L67.052 28.2285V28.312C67.052 29.0875 67.5039 29.8034 68.2057 30.1375L71.1476 31.5295C71.4211 31.6568 71.7145 31.7244 72.004 31.7244C72.2934 31.7244 72.5907 31.6607 72.8603 31.5295L75.8022 30.1375C76.504 29.8074 76.9559 29.0915 76.9559 28.312V28.2285L77.067 28.3438C77.6577 28.9484 78.5696 29.1154 79.3388 28.7654L82.7128 27.2183C83.2004 26.9956 83.5731 26.5939 83.7594 26.0928L84.8537 23.1696C85.1233 22.4498 84.9568 21.6305 84.4295 21.0737C85.0956 20.9902 85.6705 20.5805 85.9758 19.968L87.6251 16.6273C87.8947 16.0705 87.8987 15.4262 87.633 14.8614ZM78.1414 14.6984L77.1026 13.6444C77.0075 13.545 76.952 13.4138 76.952 13.2786V12.1292H80.4766L78.1414 14.6984ZM78.185 16.8659L80.8771 19.5942H76.9837L77.0313 18.3215C77.0352 18.1982 77.0828 18.0789 77.1661 17.9874L78.185 16.8659ZM78.2603 4.38575C78.411 4.2386 78.6291 4.19486 78.8233 4.27838L81.9 5.55502C82.0308 5.6107 82.1339 5.71808 82.1854 5.84932L83.4383 9.09464C83.5017 9.26566 83.478 9.45259 83.3709 9.59576L82.7524 10.423C82.6533 10.5542 82.4987 10.6338 82.3361 10.6338H76.952V5.67036L78.2603 4.38575ZM75.4652 10.6298H74.4185C74.2797 10.6298 74.1489 10.5741 74.0498 10.4747L73.4352 9.85825C73.3361 9.75882 73.2806 9.62758 73.2806 9.4844C73.2806 9.3452 73.3361 9.20998 73.4392 9.11453L75.4652 7.12598V10.6298ZM68.5348 3.40739C68.5348 3.20456 68.6537 3.02161 68.8321 2.93411L71.774 1.54213C71.9167 1.47452 72.0793 1.47452 72.218 1.54213L75.1599 2.93411C75.3423 3.02161 75.4572 3.20456 75.4572 3.40739V5.038L72.3885 8.04866C72.226 8.21172 72.0912 8.39467 71.992 8.5975C71.8929 8.39865 71.7621 8.21172 71.5956 8.04866L68.5269 5.038V3.40739H68.5348ZM70.7194 9.48837C70.7194 9.62757 70.6678 9.76279 70.5687 9.86222L69.9542 10.4787C69.8551 10.5781 69.7242 10.6338 69.5854 10.6338H68.5388V7.12995L70.5647 9.1185C70.6639 9.21793 70.7194 9.34917 70.7194 9.48837ZM60.5577 9.09464L61.8106 5.84932C61.8621 5.71808 61.9652 5.6107 62.096 5.55502L65.1727 4.27838C65.2361 4.25054 65.3035 4.2386 65.3709 4.2386C65.5057 4.2386 65.6366 4.29031 65.7357 4.38973L67.044 5.67036V10.6338H61.6599C61.4973 10.6338 61.3387 10.5542 61.2436 10.423L60.6251 9.59576C60.518 9.45259 60.4943 9.26168 60.5577 9.09464ZM65.8586 14.6984L63.5233 12.1252H67.048V13.2746C67.048 13.4138 66.9965 13.545 66.8973 13.6405L65.8586 14.6984ZM66.8339 17.9874C66.9172 18.0789 66.9647 18.1982 66.9687 18.3215L67.0163 19.5942H63.1229L65.815 16.8659L66.8339 17.9874ZM59.8282 19.5982C59.6299 19.5982 59.4515 19.4868 59.3603 19.3078L57.711 15.9671C57.6396 15.8199 57.6396 15.6569 57.707 15.5097L59.178 12.4235C59.2652 12.2445 59.4476 12.1252 59.6498 12.1252H61.2714C61.418 12.1252 61.5568 12.1888 61.6559 12.2962L64.8039 15.7603L61.0255 19.5942H59.8282V19.5982ZM67.048 26.0928L65.8744 27.2939C65.7198 27.449 65.4859 27.4927 65.2877 27.4013L61.9136 25.8542C61.7868 25.7945 61.6916 25.6911 61.644 25.5638L60.5498 22.6407C60.4784 22.4498 60.526 22.235 60.6687 22.0878L61.6559 21.0856H67.052V26.0928H67.048ZM75.4652 28.312C75.4652 28.5148 75.3462 28.6978 75.1678 28.7853L72.226 30.1773C72.0832 30.2449 71.9207 30.2449 71.7819 30.1773L68.8401 28.7853C68.6577 28.6978 68.5427 28.5148 68.5427 28.312V26.7053L71.6828 23.4957C71.8136 23.3645 71.9207 23.2173 72.004 23.0662C72.0912 23.2213 72.1982 23.3645 72.3251 23.4957L75.4652 26.7053V28.312ZM68.5348 24.5735V21.0936H69.7995C69.9423 21.0936 70.0811 21.1532 70.1762 21.2566L70.6203 21.7259C70.8145 21.9327 70.8106 22.2509 70.6123 22.4498L68.5348 24.5735ZM75.4652 24.5735L73.3876 22.4498C73.1894 22.2469 73.1894 21.9288 73.3797 21.7259L73.8198 21.2566C73.9189 21.1532 74.0577 21.0936 74.2004 21.0936H75.4652V24.5735ZM76.0639 16.9812C75.7427 17.3312 75.5603 17.7886 75.5405 18.2658L75.489 19.5982H74.1965C73.6453 19.5982 73.1141 19.8288 72.7374 20.2305L72.2973 20.6998C72.1784 20.8231 72.0793 20.9623 72 21.1055C71.9207 20.9623 71.8216 20.8271 71.7026 20.6998L71.2586 20.2305C70.8819 19.8288 70.3467 19.5982 69.7995 19.5982H68.507L68.4555 18.2658C68.4396 17.7886 68.2533 17.3352 67.9321 16.9812L66.8616 15.8L67.9559 14.6904C68.3326 14.3086 68.5388 13.8075 68.5388 13.2706V12.1212H69.5854C70.1207 12.1212 70.6282 11.9104 71.0088 11.5286L71.6233 10.9122C71.7819 10.7531 71.9048 10.5741 72 10.3832C72.0951 10.5781 72.222 10.7571 72.3806 10.9122L72.9951 11.5286C73.3758 11.9104 73.8793 12.1212 74.4185 12.1212H75.4652V13.2706C75.4652 13.8035 75.6714 14.3086 76.044 14.6904L77.1383 15.8L76.0639 16.9812ZM83.4542 22.6446L82.3599 25.5678C82.3123 25.699 82.2132 25.8025 82.0903 25.8581L78.7163 27.4052C78.518 27.4967 78.2802 27.453 78.1295 27.2979L76.9559 26.0968V21.0936H82.352L83.3392 22.0958C83.4779 22.239 83.5255 22.4537 83.4542 22.6446ZM86.285 15.9631L84.6357 19.3039C84.5484 19.4828 84.3661 19.5942 84.1678 19.5942H82.9665L79.1881 15.7603L82.3361 12.2962C82.4352 12.1888 82.574 12.1252 82.7207 12.1252H84.3423C84.5405 12.1252 84.7269 12.2405 84.8141 12.4235L86.285 15.5057C86.3564 15.6529 86.3564 15.8199 86.285 15.9631Z"
          fill="white"
        />
        <path
          d="M0 54.7001L6.21674 39.2808L5.50705 37.515H7.88194L14.8084 54.7001H12.4573L10.4749 49.8401H2.88634L0.903964 54.7001H0ZM3.20749 49.0048H10.1577L6.68062 40.4103L3.20749 49.0048Z"
          fill="white"
        />
        <path
          d="M24.4784 37.515C25.6877 37.515 26.7145 37.7178 27.563 38.1275C28.4114 38.5371 29.0775 39.0621 29.5573 39.6984C30.037 40.3388 30.3423 41.0467 30.4612 41.8222C30.5841 42.6017 30.5207 43.3574 30.2788 44.0931C30.037 44.8289 29.6088 45.4931 29.0062 46.0817C28.4035 46.6703 27.6185 47.1038 26.6551 47.3822L30.0568 54.7001H29.1529L25.8225 47.5811C25.6084 47.6129 25.3903 47.6367 25.1603 47.6566C24.9304 47.6725 24.7044 47.6805 24.4744 47.6805H19.015V54.704H16.6401V37.519H24.4784V37.515ZM24.3793 46.8453C25.2277 46.8453 25.9335 46.6385 26.4965 46.2209C27.0595 45.8033 27.4797 45.2783 27.7573 44.6499C28.0348 44.0216 28.1736 43.3415 28.1736 42.6137C28.1736 41.8859 28.0348 41.2058 27.7573 40.5774C27.4797 39.949 27.0595 39.424 26.4965 39.0064C25.9335 38.5888 25.2277 38.382 24.3793 38.382H19.0189V46.8532H24.3793V46.8453Z"
          fill="white"
        />
        <path
          d="M31.3097 54.7001L37.5264 39.2808L36.8167 37.515H39.1916L46.1181 54.7001H43.767L41.7846 49.8401H34.196L32.2137 54.7001H31.3097ZM34.5132 49.0048H41.4634L37.9863 40.4103L34.5132 49.0048Z"
          fill="white"
        />
        <path
          d="M47.9537 37.515H55.0269C56.1687 37.515 57.148 37.6661 57.9647 37.9684C58.7815 38.2706 59.4317 38.6604 59.9233 39.1337C60.415 39.607 60.748 40.1399 60.9264 40.7285C61.1048 41.3171 61.1207 41.9018 60.974 42.4824C60.8273 43.0631 60.522 43.604 60.0542 44.1011C59.5903 44.6022 58.9639 45.0039 58.1828 45.3181C59.1462 45.5806 59.9233 45.9942 60.522 46.5589C61.1167 47.1237 61.5291 47.7521 61.759 48.4481C61.989 49.1441 62.0365 49.8599 61.9057 50.5957C61.7749 51.3315 61.4656 52.0036 60.974 52.6081C60.4824 53.2126 59.8203 53.7137 58.9797 54.1075C58.1392 54.5012 57.1163 54.6961 55.907 54.6961H47.9537V37.515ZM54.9515 45.0277C55.8 45.0277 56.5017 44.8647 57.0568 44.5386C57.6119 44.2124 58.0321 43.8028 58.3176 43.3097C58.6031 42.8205 58.7458 42.2835 58.7458 41.7029C58.7458 41.1222 58.6031 40.5853 58.3176 40.0962C58.0321 39.607 57.6119 39.1973 57.0568 38.8672C56.5017 38.5411 55.8 38.378 54.9515 38.378H50.3009V45.0317H54.9515V45.0277ZM55.8079 53.8649C56.6564 53.8649 57.3621 53.67 57.9251 53.2763C58.4881 52.8825 58.9123 52.3894 59.1978 51.7888C59.4832 51.1923 59.626 50.548 59.626 49.8599C59.626 49.1719 59.4832 48.5316 59.1978 47.931C58.9123 47.3345 58.4881 46.8373 57.9251 46.4476C57.3621 46.0578 56.6564 45.859 55.8079 45.859H50.3009V53.8649H55.8079Z"
          fill="white"
        />
        <path
          d="M65.2084 54.7001V37.515H77.4238V38.3741H67.5833V44.1448H74.585V44.98H67.5833V53.8689H77.4238V54.704H65.2084V54.7001Z"
          fill="white"
        />
        <path
          d="M90.7136 41.1978L89.9801 41.2734C89.9801 40.6847 89.8493 40.1717 89.5876 39.7382C89.3259 39.3047 88.9771 38.9388 88.537 38.6445C88.0969 38.3502 87.5933 38.1275 87.0303 37.9803C86.4673 37.8331 85.8925 37.7576 85.3057 37.7576C84.5881 37.7576 83.9339 37.8451 83.3471 38.0161C82.7603 38.1871 82.2568 38.4138 81.8405 38.6922C81.4242 38.9706 81.107 39.2967 80.885 39.6746C80.6629 40.0524 80.5559 40.4461 80.5559 40.8518C80.5718 41.5875 80.8255 42.1841 81.3132 42.6454C81.8008 43.1028 82.4193 43.5045 83.1608 43.8505C83.9022 44.1925 84.707 44.5226 85.5713 44.8328C86.4356 45.1431 87.2405 45.5209 87.9819 45.9623C88.7233 46.4038 89.3537 46.9566 89.8651 47.6208C90.3806 48.285 90.6541 49.1401 90.6859 50.186C90.7176 50.8423 90.5986 51.4746 90.329 52.0871C90.0594 52.6995 89.659 53.2404 89.1317 53.7058C88.6004 54.1711 87.9423 54.5449 87.1493 54.8233C86.3563 55.1017 85.4484 55.2409 84.4215 55.2409C83.7198 55.2409 83.0299 55.1534 82.3519 54.9824C81.674 54.8114 81.0753 54.5529 80.5519 54.2109C80.0286 53.8688 79.6083 53.4353 79.2911 52.9103C78.974 52.3854 78.8154 51.7649 78.8154 51.0451L79.5013 50.9695C79.5013 51.5581 79.6361 52.0751 79.9057 52.5166C80.1753 52.9581 80.5281 53.3279 80.9722 53.6223C81.4163 53.9166 81.9119 54.1393 82.4669 54.2864C83.022 54.4336 83.5929 54.5091 84.1797 54.5091C84.8973 54.5091 85.5515 54.4216 86.1383 54.2506C86.725 54.0796 87.2286 53.845 87.6449 53.5507C88.0612 53.2564 88.3823 52.9183 88.6123 52.5325C88.8423 52.1468 88.9533 51.749 88.9533 51.3434C88.9533 50.7707 88.8105 50.2855 88.5251 49.8838C88.2396 49.4821 87.859 49.1321 87.3872 48.8299C86.9154 48.5276 86.3801 48.2571 85.7854 48.0185C85.1907 47.7799 84.5762 47.5413 83.9497 47.2947C83.3233 47.0481 82.7048 46.7777 82.1021 46.4833C81.4995 46.189 80.9603 45.8351 80.4845 45.4294C80.0127 45.0198 79.6242 44.5386 79.3228 43.9818C79.0215 43.425 78.855 42.7528 78.8193 41.9693C78.8035 41.333 78.9264 40.7126 79.1881 40.116C79.4497 39.5194 79.8462 38.9905 80.3735 38.5331C80.9048 38.0758 81.5629 37.7059 82.3559 37.4275C83.1488 37.1491 84.0568 37.0099 85.0837 37.0099C85.8013 37.0099 86.4951 37.0974 87.1651 37.2684C87.8352 37.4394 88.4339 37.6979 88.9651 38.04C89.4964 38.382 89.9207 38.8195 90.2378 39.3405C90.5511 39.8535 90.7136 40.4779 90.7136 41.1978Z"
          fill="white"
        />
        <path
          d="M102.386 37.0974C103.69 37.0974 104.86 37.2803 105.887 37.6502C106.914 38.0201 107.806 38.5172 108.555 39.1496C109.304 39.778 109.923 40.5137 110.403 41.3489C110.882 42.1841 111.227 43.063 111.43 43.9897C111.632 44.9164 111.699 45.855 111.624 46.8135C111.548 47.772 111.346 48.6906 111.013 49.5775C110.68 50.4605 110.2 51.2798 109.582 52.0314C108.963 52.7831 108.21 53.4155 107.33 53.9206L109.804 57.7982H107.453L105.47 54.6802C104.539 54.9745 103.512 55.1216 102.386 55.1216C100.836 55.1216 99.4758 54.8631 98.3101 54.3501C97.1445 53.837 96.1731 53.1569 95.3961 52.3138C94.619 51.4706 94.0401 50.5082 93.6595 49.4304C93.2749 48.3486 93.0846 47.247 93.0846 46.1175C93.0846 44.988 93.2749 43.8823 93.6595 42.8045C94.0441 41.7228 94.6229 40.7643 95.3961 39.9211C96.1731 39.078 97.1405 38.3979 98.3101 37.8849C99.4797 37.3718 100.836 37.0974 102.386 37.0974ZM102.386 37.8093C101.244 37.8093 100.245 38.0479 99.3886 38.5212C98.5322 38.9945 97.8185 39.6229 97.2476 40.3984C96.6767 41.1779 96.2485 42.0648 95.963 43.0631C95.6776 44.0613 95.5348 45.0755 95.5348 46.1095C95.5348 47.1396 95.6776 48.1577 95.963 49.156C96.2485 50.1542 96.6767 51.0411 97.2476 51.8206C97.8185 52.6001 98.5322 53.2246 99.3886 53.6978C100.245 54.1711 101.244 54.4097 102.386 54.4097C103.528 54.4097 104.523 54.1711 105.371 53.6978C106.22 53.2246 106.93 52.5962 107.5 51.8206C108.071 51.0451 108.5 50.1542 108.785 49.156C109.071 48.1577 109.213 47.1436 109.213 46.1095C109.213 45.0794 109.071 44.0653 108.785 43.0631C108.5 42.0648 108.071 41.1779 107.5 40.3984C106.93 39.6229 106.22 38.9945 105.371 38.5212C104.527 38.0439 103.528 37.8093 102.386 37.8093Z"
          fill="white"
        />
        <path
          d="M114.823 48.5117V37.5111H117.198V49.0526C117.198 49.8719 117.337 50.5957 117.614 51.2241C117.892 51.8525 118.277 52.3854 118.764 52.8189C119.252 53.2524 119.831 53.5786 120.489 53.8013C121.151 54.024 121.873 54.1314 122.654 54.1314C123.272 54.0996 123.871 53.9683 124.442 53.7376C125.013 53.507 125.52 53.1809 125.96 52.7553C126.4 52.3298 126.753 51.8048 127.011 51.1843C127.273 50.5639 127.403 49.852 127.403 49.0486V37.5071H128.236V48.5077C128.236 49.506 128.07 50.4207 127.733 51.244C127.4 52.0712 126.932 52.7752 126.337 53.3558C125.742 53.9365 125.029 54.3859 124.196 54.7081C123.363 55.0262 122.459 55.1853 121.48 55.1853C120.648 55.1853 119.831 55.0421 119.034 54.7558C118.237 54.4694 117.519 54.0479 116.893 53.4911C116.266 52.9343 115.763 52.2383 115.386 51.4031C115.01 50.5758 114.823 49.6094 114.823 48.5117Z"
          fill="white"
        />
        <path
          d="M131.785 54.7001V37.515H144V38.3741H134.16V44.1448H141.161V44.98H134.16V53.8689H144V54.704H131.785V54.7001Z"
          fill="white"
        />
        <path
          d="M52.1643 69.7853V61.0397H53.3736V63.8236H57.9568V61.0397H58.381V69.7853H57.9568V64.2532H53.3736V69.7853H52.1643Z"
          fill="white"
        />
        <path
          d="M64.7405 60.8289C65.5295 60.8289 66.2194 60.9601 66.8062 61.2226C67.3969 61.4851 67.8846 61.8311 68.2771 62.2606C68.6656 62.6901 68.963 63.1793 69.1612 63.7282C69.3595 64.277 69.4586 64.8417 69.4586 65.4144C69.4586 65.9871 69.3595 66.5519 69.1612 67.1007C68.963 67.6496 68.6656 68.1388 68.2771 68.5683C67.8885 68.9978 67.3969 69.3438 66.8062 69.6063C66.2154 69.8688 65.5295 70.0001 64.7405 70.0001C63.9515 70.0001 63.2617 69.8688 62.667 69.6063C62.0722 69.3438 61.5806 68.9978 61.1841 68.5683C60.7876 68.1388 60.4943 67.6496 60.3 67.1007C60.1057 66.5519 60.0066 65.9871 60.0066 65.4144C60.0066 64.8417 60.1057 64.277 60.3 63.7282C60.4943 63.1793 60.7916 62.6901 61.1841 62.2606C61.5766 61.8311 62.0722 61.4851 62.667 61.2226C63.2617 60.9601 63.9515 60.8289 64.7405 60.8289ZM64.7405 61.1908C64.1577 61.1908 63.6502 61.3101 63.2141 61.5527C62.778 61.7953 62.4132 62.1135 62.1238 62.5072C61.8344 62.9049 61.6163 63.3543 61.4696 63.8634C61.3229 64.3725 61.2515 64.8895 61.2515 65.4105C61.2515 65.9315 61.3229 66.4525 61.4696 66.9576C61.6163 67.4666 61.8344 67.9161 62.1238 68.3138C62.4132 68.7075 62.778 69.0296 63.2141 69.2683C63.6502 69.5109 64.1577 69.6302 64.7405 69.6302C65.3233 69.6302 65.8269 69.5109 66.259 69.2683C66.6912 69.0257 67.052 68.7075 67.3414 68.3138C67.6308 67.92 67.8489 67.4666 67.9956 66.9576C68.1423 66.4485 68.2136 65.9315 68.2136 65.4105C68.2136 64.8895 68.1423 64.3685 67.9956 63.8634C67.8489 63.3543 67.6308 62.9049 67.3414 62.5072C67.052 62.1135 66.6912 61.7953 66.259 61.5527C65.8269 61.3101 65.3194 61.1908 64.7405 61.1908Z"
          fill="white"
        />
        <path
          d="M69.744 61.4772V61.0397H77.4277V61.4772H74.1885V69.7853H72.9951V61.4772H69.744Z"
          fill="white"
        />
        <path
          d="M78.4863 69.7853V61.0397H84.6991V61.4772H79.6916V64.4123H83.252V64.8378H79.6916V69.3598H84.6991V69.7853H78.4863Z"
          fill="white"
        />
        <path
          d="M85.6348 61.0397H86.8321V69.3598H91.8396V69.7853H85.6387V61.0397H85.6348Z"
          fill="white"
        />
      </svg>
      <div className={styles.mobileShelfButton} onClick={() => {setPlayAnim(!opened);}}>
        <div className={styles.line} />
        <div className={styles.line} />
        <div className={styles.line} />
      </div>
      <div
        className={styles.shelf}
        style={{ top: opened ? "0" : "-200lvh"}}
      >
     <div className={styles.subpages}>
        <p
          onClick={() => {
            window.open("/", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Home"
          ) : currentLanguage === "sq" ? (
            "Ballina"
          ) : currentLanguage === "sr" ? (
            <>Dom</>
          ) : (
            <>Heim</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/rooms", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Rooms"
          ) : currentLanguage === "sq" ? (
            "Dhomat"
          ) : currentLanguage === "sr" ? (
            <>Sobe</>
          ) : (
            <>Räume</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/gallery", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Gallery"
          ) : currentLanguage === "sq" ? (
            "Galeria"
          ) : currentLanguage === "sr" ? (
            <>Galerija</>
          ) : (
            <>Galerie</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/about", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "About"
          ) : currentLanguage === "sq" ? (
            "Rreth"
          ) : currentLanguage === "sr" ? (
            <>O nama</>
          ) : (
            <>Über Uns</>
          )}
        </p>
        <p
          onClick={() => {
            window.open("/contact", "_self");
          }}
        >
          {currentLanguage === "en" ? (
            "Contact"
          ) : currentLanguage === "sq" ? (
            "Kontakt"
          ) : currentLanguage === "sr" ? (
            <>Kontakt</>
          ) : (
            <>Kontakt</>
          )}
        </p>

        <button
        onClick={() => {
          window.open("https://www.booking.com/Share-hAUEA1", "_self");
        }}
        style={{display:'unset'}}
      >
        {currentLanguage === "en" ? (
          "Book Now"
        ) : currentLanguage === "sq" ? (
          "Rezervoni"
        ) : currentLanguage === "sr" ? (
          <>Rezerva</>
        ) : (
          <>Reservieren</>
        )}
      </button>
      </div>
      </div>
      <button
        onClick={() => {
          window.open("https://www.booking.com/Share-hAUEA1", "_self");
        }}
      >
        {currentLanguage === "en" ? (
          "Book Now"
        ) : currentLanguage === "sq" ? (
          "Rezervoni"
        ) : currentLanguage === "sr" ? (
          <>Rezerva</>
        ) : (
          <>Reservieren</>
        )}
      </button>
      <div className={styles.languages}>
        <p
          style={{
            textDecoration: currentLanguage === "en" ? "underline" : "none",
          }}
          onClick={() => {
            setLanguage("en");
          }}
        >
          EN
        </p>
        <p
          style={{
            textDecoration: currentLanguage === "sq" ? "underline" : "none",
          }}
          onClick={() => {
            setLanguage("sq");
          }}
        >
          AL
        </p>
        <p
          style={{
            textDecoration: currentLanguage === "sr" ? "underline" : "none",
          }}
          onClick={() => {
            setLanguage("sr");
          }}
        >
          MN
        </p>
        <p
          style={{
            textDecoration: currentLanguage === "de" ? "underline" : "none",
          }}
          onClick={() => {
            setLanguage("de");
          }}
        >
          DE
        </p>
      </div>
    </div>
  );
};

export default Header;
